import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-screen bg-gray-50" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { class: "text-red-600 text-lg font-semibold" }
const _hoisted_4 = { class: "text-gray-600 mt-2" }
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = { class: "text-gray-600 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.errorHeading), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto" }, null, -1)),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.loaderMessage), 1)
        ]))
  ]))
}